import { useNode } from '@craftjs/core';
import { AI_GENERATION_LOADER_NODE_NAME } from '@/utils/constants';

/**
 * Loading animation component displayed while AI generates page sections.
 *
 * Shows a full-width container with animated wave bars to indicate generation progress.
 * This component is automatically added at the bottom of the page when generation starts
 * and removed when generation completes.
 */
const AiGenerationLoader = () => {
  const {
    connectors: { connect },
  } = useNode();

  return (
    <div
      ref={(ref) => {
        if (ref) connect(ref);
      }}
      className="flex w-full items-center justify-center bg-indigo-50 py-16"
    >
      <div className="flex items-center gap-1">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="h-8 w-1 rounded bg-indigo-500"
            style={{
              animation: 'waveAnimation 1.2s ease-in-out infinite',
              animationDelay: `${i * 0.1}s`,
            }}
          />
        ))}
      </div>
      <style>
        {`
          @keyframes waveAnimation {
            0%, 100% {
              transform: scaleY(0.4);
            }
            50% {
              transform: scaleY(1);
            }
          }
        `}
      </style>
    </div>
  );
};

AiGenerationLoader.craft = {
  displayName: AI_GENERATION_LOADER_NODE_NAME,
  props: {},
  custom: {
    displayName: 'AI Generation Loader',
    isLocked: true,
  },
  rules: {
    canDrag: () => false,
    canDrop: () => false,
    canMoveIn: () => false,
    canMoveOut: () => false,
  },
};

export default AiGenerationLoader;
